export default __webpack_public_path__ + "static/media/tongyigongji.774e9c5e.jpg";